import React, { useState } from 'react';

const toTitleCase = (value) =>
  (value || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

const PetNameInput = ({ initialName = '', onSubmit, onBack }) => {
  const [petName, setPetName] = useState(initialName);
  const [showNameError, setShowNameError] = useState(false);
  const cleanedPetName = toTitleCase(petName);
  const canContinue = Boolean(cleanedPetName);
  const showBackButton = typeof onBack === 'function';

  const handleContinue = () => {
    if (!cleanedPetName) {
      setShowNameError(true);
      return;
    }

    setShowNameError(false);
    onSubmit(cleanedPetName);
  };

  return (
    <div className="max-w-2xl mx-auto overflow-x-hidden">
      <div className="text-center mb-5 lg:mb-6">
        <h2 className="text-3xl sm:text-4xl font-bold text-purple-700 mb-2">What is your pet&apos;s name?</h2>
      </div>

      <div className="bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg">
        <input
          type="text"
          value={petName}
          onChange={(event) => setPetName(event.target.value)}
          placeholder="e.g. Luna"
          maxLength={32}
          className={`w-full border rounded-2xl px-5 py-4 text-lg lg:text-xl text-gray-800 focus:outline-none focus:ring-2 ${
            showNameError ? 'border-red-300 focus:ring-red-200' : 'border-purple-200 focus:ring-purple-200'
          }`}
        />
        {showNameError ? (
          <p className="mt-2 text-base lg:text-lg text-red-600">Please enter your pet&apos;s name.</p>
        ) : null}

        <div className="mt-5 flex gap-3">
          {showBackButton ? (
            <button
              onClick={onBack}
              className="w-1/3 border border-purple-200 text-purple-600 text-base lg:text-lg font-semibold py-3 px-4 rounded-full hover:bg-purple-50 transition-all duration-300"
            >
              Back
            </button>
          ) : null}
          <button
            onClick={handleContinue}
            disabled={!canContinue}
            className={`${showBackButton ? 'w-2/3' : 'w-full'} text-base lg:text-lg font-bold py-3 px-6 rounded-full shadow-lg transition-all duration-300 ${
              canContinue
                ? 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white cursor-pointer'
                : 'bg-purple-100 text-purple-400 cursor-not-allowed shadow-none'
            }`}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default PetNameInput;
